export default {"src":"/_next/static/media/fit-to-screen-disabled.f475a74e.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};